import { Product } from '../product.model';
import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/pages/products/products.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import {  Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-products-detail',
  templateUrl: './products-detail.component.html',
  styleUrls: ['./products-detail.component.css']
})
export class ProductsDetailComponent implements OnInit {
  
  public product:Product;

  private detailSubscription:Subscription;

  constructor(public productServ: ProductsService,public navigator:Router,public toastr:ToastrManager) {
    this.detailSubscription=new Subscription();
   }

  ngOnDestroy(): void {
    if(this.detailSubscription) return

    this.detailSubscription.unsubscribe();
  }

  ngOnInit() {
    this.detailSubscription.add(this.productServ.getObject('product').subscribe(product=>this.product=product));
  }

  editProduct(product:Product){
    this.navigator.navigate(['/admin/products/edit']).then(()=>{
      this.productServ.setObject(product,'product');
    })
  }

  updateImageProfile(event:any,product:any){

    if(confirm('Deseja realmente actualizar o Logotipo?')){

            // criando um formData
            let formData = new FormData();


            // convertendo o formproduct para formData
            formData.append('id', product['id'])
      
            console.log(event.target.files[0])
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('image', event.target.files[0], event.target.files[0].name)

      // save image
      this.productServ.updateImageWithNoData(formData,'product')
      .subscribe(message=>{
        this.toastr.successToastr(message)
      })

    }
  }
}